import { useEffect } from 'react';
import usePrevious from 'react-hooks/usePrevious';
import { scrollToValue } from './scrollTo';
const useAutoScroll = ({ name, isOpen, elements, selectedValue }) => {
    const wasOpen = usePrevious(isOpen);
    useEffect(() => {
        if (!wasOpen && isOpen) {
            scrollToValue(name, elements, selectedValue);
        }
    }, [name, isOpen, wasOpen, elements, selectedValue]);
};
export default useAutoScroll;
//# sourceMappingURL=useAutoScroll.js.map